import { useMount } from 'react-use';

import {
  SystemNotificationsPermissionSoftPrompt,
  SystemNotificationsPermissionSoftPromptProps,
} from './SystemNotificationsPermissionSoftPrompt';
import { useRequestNotificationPermissionCallback } from './useRequestNotificationPermissionCallback';
import { useSystemNotificationsPermissionTrackingEvents } from './useSystemNotificationsPermissionTrackingEvents';

export function SystemNotificationsPermissionSoftPromptWrapper({
  closeButtonProps,
  closeToast,
  ...passThroughProps
}: Omit<SystemNotificationsPermissionSoftPromptProps, 'onClick'>) {
  const requestNotificationPermission = useRequestNotificationPermissionCallback();
  const { trackPermissionSoftPromptViewed, trackPermissionSoftPromptDismissed } =
    useSystemNotificationsPermissionTrackingEvents();

  useMount(trackPermissionSoftPromptViewed);

  return (
    <SystemNotificationsPermissionSoftPrompt
      {...passThroughProps}
      closeToast={closeToast}
      closeButtonProps={{
        ...closeButtonProps,
        onClick: () => {
          trackPermissionSoftPromptDismissed();
          closeButtonProps.onClick();
        },
      }}
      onClick={() => {
        requestNotificationPermission();
        closeToast();
      }}
    />
  );
}
